// Shared segmented choice control with explicit selected state in both palettes.
interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedProps<T extends string> {
  value: T;
  onChange: (next: T) => void;
  options: SegmentedOption<T>[];
  size?: 'sm' | 'md';
  className?: string;
}

export function Segmented<T extends string>({
  value,
  onChange,
  options,
  size = 'md',
  className,
}: SegmentedProps<T>) {
  const padding = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div
      className={
        'no-scrollbar flex gap-1 overflow-x-auto rounded-lg bg-muted p-1 [scroll-snap-type:x_mandatory] ' +
        (className ?? '')
      }
      role="radiogroup"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            type="button"
            role="radio"
            aria-checked={active}
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={
              'flex min-h-[44px] shrink-0 items-center justify-center rounded-md px-3 font-medium [scroll-snap-align:start] ' +
              padding +
              ' ' +
              (active
                ? 'bg-primary font-bold text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground')
            }
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
